import React, { useEffect } from "react";
import { Route, Redirect } from "react-router-dom";
import { ACCESS_TOKEN_VERIFY_INTERVAL, LAYOUTS } from "constant";
import { verifyAccessToken } from "helpers/verifyAccessToken";

/* Services */
import { getAuthToken } from "../../services/Auth.service";

/* Components */
import Footer from "../layout/Footer";
import ErrorBoundary from "components/utils/ErrorBoundary";
import NoPermissionComponent from "components/ui/NoPermissionComponent";

const PrivateRoute: React.FC<any> = ({
  component: Component,
  layout,
  setLayout,
  props,
  loading,
  isAccess,
  viewPermission,
  userPermissions,
  ...rest
}) => {
  useEffect(() => {
    const refreshTokenInterval = setInterval(() => {
      verifyAccessToken();
    }, ACCESS_TOKEN_VERIFY_INTERVAL);

    return () => {
      clearInterval(refreshTokenInterval);
    };
  }, []);
  
  return (
    <Route
      {...rest}
      render={(matchProps) => {
        if (loading !== undefined && isAccess !== undefined && !loading && !isAccess) {
          return (
            <Redirect
              to={{
                pathname: "/track",
                state: { from: matchProps.location },
              }}
            />
          );
        }

        let isLoggedIn = getAuthToken();
        if (!isLoggedIn) {
          return (
            <Redirect
              to={{
                pathname: "/",
                state: { from: matchProps.location },
              }}
            />
          );
        }
        if (setLayout) {
          setLayout(layout);
        }

        if (!viewPermission && userPermissions) {
          return (
            <NoPermissionComponent isLayoutDefault={layout === LAYOUTS.DEFAULT} />
          );
        } else {
        // 'default',
        // 'auth', // For the pages of authentication eg: login, signup,...,
        // 'compact', // Header + hamberger menu for the side bar
        switch (layout) {
          case LAYOUTS.DEFAULT:
            return (
              <main className={`main-panel p-0 main-panel-private`}>
                <div className="main">
                  <ErrorBoundary>
                    <Component {...matchProps} {...props} />
                  </ErrorBoundary>
                </div>
                <Footer />
              </main>
            );
          case LAYOUTS.COMPACT:
            return (
              <main
                className={`main-panel-private ${
                  matchProps.location.pathname === "/create-order/order" ? "h-auto" : ""
                }`}
              >
                <div className="main">
                  <ErrorBoundary>
                    <Component {...matchProps} {...props} />
                  </ErrorBoundary>
                </div>
                <Footer isFullWidth />
              </main>
            );
          case LAYOUTS.AUTH:
            return (
              <ErrorBoundary>
                <Component {...matchProps} {...props} />
              </ErrorBoundary>
            );

          default:
            break;
        }
        }
      }}
    />
  );
};

export default PrivateRoute;
